module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-69-min.7a120f57.jpg";